<kendo-upload
   [saveUrl]="uploadSaveUrl"
   [removeUrl]="uploadRemoveUrl"
   (select)="onSelect($event)"
   (remove)="onRemove()"
   [multiple]="false"
>
   <kendo-upload-messages select="{{ 'samwin.upload.upload_image' | translate }}"> </kendo-upload-messages>
</kendo-upload>
